import { accountPaths, UserIHaveSentInviteTo } from '@todesktop/shared';
import { QuerySnapshot, doc, collection } from 'firebase/firestore';
import { getData, getCollectionSnapshotWhere } from './common';
import { firestore } from './firestore';
import { callFirebaseFunction } from './functions';
import { ensureCurrentUserHasEmailClaim } from './auth';

const normalizeInviteEmail = (email: string) => email.trim().toLowerCase();

export const getInvitedUserData = (id: string, email: string) =>
  getData<UserIHaveSentInviteTo>(
    doc(
      firestore,
      `/${accountPaths.invitation(id, normalizeInviteEmail(email))}`,
    ),
  );

export const getInviteLookupEmail = async (fallbackEmail: string) => {
  const idTokenResult = await ensureCurrentUserHasEmailClaim(fallbackEmail);
  const claimEmail =
    typeof idTokenResult?.claims?.email === 'string'
      ? idTokenResult.claims.email
      : fallbackEmail;

  return normalizeInviteEmail(claimEmail);
};

export const getInvitedUsers = (id: string) =>
  collection(firestore, accountPaths.invitations(id));

export const onInvitedUsersUpdate = (
  id: string,
  handler: (arg: UserIHaveSentInviteTo[], snapshot?: QuerySnapshot) => void,
) => {
  if (id) {
    return getCollectionSnapshotWhere<UserIHaveSentInviteTo>(
      getInvitedUsers(id),
      { orderBy: { fieldPath: 'email', direction: 'desc' } },
      handler,
    );
  }
};

export const deleteInvitedUser = async ({
  accountId,
  email,
  authentication,
}: {
  accountId: string;
  email: string;
  authentication: any;
}) => {
  const removeInvitedUserFunction = callFirebaseFunction('removeInvitedUser');
  return await removeInvitedUserFunction({ accountId, email, authentication });
};

export const updateInvitedUser = async ({
  accountId,
  email,
  permissions,
  authentication,
}: {
  accountId: string;
  email: string;
  permissions: UserIHaveSentInviteTo['permissions'];
  authentication: any;
}) => {
  const updateAccountInvitePermissionsCallable = callFirebaseFunction(
    'updateAccountInvitePermissions',
  );
  const { data } = await updateAccountInvitePermissionsCallable({
    accountId,
    email,
    permissions,
    authentication,
  });
  return data as {
    accountId: string;
    invitedUser: UserIHaveSentInviteTo;
  };
};
